// extracted by mini-css-extract-plugin
export default {"main":"undoRendoBlock_main__zyaz9","circle":"undoRendoBlock_circle__AsQmb"};